import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import copy from "copy-to-clipboard";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { BsSearch } from "react-icons/bs";
import ThemeControls from "../AllThemesControl.js";
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import TableSortLabel from '@mui/material/TableSortLabel';
import Loading from '../../images/Table/Loading.gif';
import { FormJSONCreateContext } from '../FormJSONCreateContext.js';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { visuallyHidden } from '@mui/utils';
import { FormContext } from '../Forms/FormContext.js';
import Element from "../../FormsControls/Element.js"
import * as XLSX from 'xlsx';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Button from '@mui/material/Button';
//testing
//import SuccessPage from '../SuccessPage'
//JSON CONTEXT

import demo from './demo.json';

//APISERVICES
import { APIGET, APIDEL, APIPATCH, APIPOST } from '../../services/APIServices.js';
//import SuccessPage from '../SuccessPage';

//Navigation
import { useNavigate, Link } from 'react-router-dom';
import { render } from '@testing-library/react';
import { CenterFocusStrongOutlined } from '@mui/icons-material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


export default function Details(obj) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const apiContextObj = obj.apiContextObj;
  const contextJson = obj.contextJson;
  const searchJson = obj.searchJson || {};
  const _columns = obj.viewJson[apiContextObj?.detailsFlow?.columns];
  const [dataSource, setDataSource] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [editRowOpen, setEditRowOpen] = React.useState(false);
  const [noData, setNoData] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [searchValue, setSearchValue] = useState('');
  // const [searchQuery, setSearchQuery] = useState("");
  const [viewPosition, setViewPosition] = useState();
  const [openDetails, setOpenDetails] = React.useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [loading, setLoading] = useState(true);
  const [editJson, setEditJson] = useState(obj.EditJson);
  const [refresh, setRefresh] = useState(false)
  const isDisabled = dataSource.length === 0;

  const apiPath = apiContextObj.detailsFlow.apiContextGet;

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const formFieldsJson = obj.createJson;
  //Setting_data for view table.===>
  let navigate = useNavigate();

  console.log(searchJson)

const {index, dataArr, detail}=obj

function getSuccessResponse(res) {
  // console.log(res)
  if (res.dataRecevied) {
      if (res.dataRecevied.data) {
          setLoading(false);
            if (Array.isArray(res.dataRecevied.data)) {
            setDataSource(res.dataRecevied.data);
            setFilteredData(res.dataRecevied.data);
          } else if (typeof res.dataRecevied.data === 'object') {
            if(apiContextObj?.detailsFlow?.key){
              setDataSource(res.dataRecevied.data[apiContextObj?.detailsFlow?.key]);
              setFilteredData(res.dataRecevied.data[apiContextObj?.detailsFlow?.key]);
            }else{
              setDataSource([res.dataRecevied.data]);
              setFilteredData([res.dataRecevied.data]);
            }
          } else {
              console.log("The data is neither an array nor an object.");
          }
    
      }
  }
}
function handleErrorMsg(msg){
  setErrorMsg(msg)
  setErrorOpen(true)
  
}
async function postingData(path, data) {
  try {
    const response = await APIPOST(path, data, contextJson, getSuccessResponse, handleErrorMsg);
    if (response) {
      return response.data
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

  useEffect(() => {
  
    async function settingData(url) {
      return await APIGET(url).then(data => {
        try {
          if (data.data) {
            if (Array.isArray(data.data)) {
            setDataSource(data.data);
            setFilteredData(data.data);
          } else if (typeof data.data === 'object') {
            if(apiContextObj?.detailsFlow?.key){
              setDataSource(data.data[apiContextObj?.detailsFlow?.key]);
              setFilteredData(data.data[apiContextObj?.detailsFlow?.key]);
            }else{
              setDataSource([data.data]);
              setFilteredData([data.data]);
            }
          } else {
              console.log("The data is neither an array nor an object.");
          }
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          alert('Error fetching data', error);
          obj.close();
        } finally {
          setLoading(false);
        }
      })
    }

    if (apiPath) {
      if(apiContextObj?.detailsFlow?.type&&apiContextObj?.detailsFlow?.type==="post"){
        const data={}
        const path = apiPath.apiContext
        const id = apiPath.id;
        if (Array.isArray(id)) {
          id.forEach((key) => {
            const margData={...dataArr,...detail}
            const value = margData[key.temp_id];
            if(key?.field_value){
              data[key.field_id] = key?.field_value
            }else{
              if (value !== undefined && value) {
                data[key.field_id] = value
              }else{
                Object.keys(searchJson).forEach((searchKey) => {
                  if (searchKey !== "xioFEConfig") {
                    searchJson[searchKey].fields.forEach((field) => {
                      if (field.field_id === key.temp_id) {
                        data[key.field_id] = field.field_value;
                      }
                    });
                  }
                });
              }
            }
          });
        }
        postingData(path,data)
      }else if(apiContextObj?.detailsFlow?.type&&apiContextObj?.detailsFlow?.type==="custom"){
        let formattedString = "";
        const id = apiPath.id;
        if (Array.isArray(id)) {
          id.forEach((key) => {
            const margData={...dataArr,...detail}
            let value = margData[key.temp_id];
            if(value===null){
              value=0
            }
            if (value !== undefined) {
              formattedString += `${key.field_id}=${encodeURIComponent(value)}&`;
            }
          });
        }
        const url = apiPath.apiContext + formattedString;
        settingData(url);
      }else{
        const id = apiPath.id;
      if (typeof id === 'string') {
        const url = apiPath.apiContext + apiPath.type + dataArr[apiPath.id];
        settingData(url);
      } else if (Array.isArray(id)) {
        let formattedString = "";
        id.forEach((key) => {
          const value = dataArr[key];
          if (value !== undefined) {
            formattedString += `${key}=${encodeURIComponent(value)}&`;
          }
        });
        const url = apiPath.apiContext + formattedString;
        settingData(url);
      }
      }
    }
  }, [apiPath, refresh])

  // console.log(dataSource)  

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  
  const parseDate = (dateStr) => {
    // Try to parse different date formats
    let parsedDate;
  
    // Format: "MM/DD/YYYY"
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      parsedDate = new Date(dateStr);
    } 
    // Format: "dd-mm-yyyy"
    else if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      parsedDate = new Date(`${year}-${month}-${day}`);
    }
    // Format: "yyyy-mm-dd hh:mm:ss"
    else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateStr)) {
      parsedDate = new Date(dateStr);
    } 
    // Return invalid date if format is not recognized
    else {
      parsedDate = new Date(NaN);
    }
  
    return parsedDate;
  };
  
  // Function to handle comparisons for sorting
  function descendingComparator(a, b, orderBy) {
    const aValue = a[orderBy];
    const bValue = b[orderBy];
  
    // Determine if the values are dates
    const isDateA = aValue && !isNaN(parseDate(aValue).getTime());
    const isDateB = bValue && !isNaN(parseDate(bValue).getTime());
  
    if (isDateA && isDateB) {
      // Date comparison
      return parseDate(aValue) - parseDate(bValue);
    }
  
    // Determine if the values are numbers
    const isNumericA = !isNaN(parseFloat(aValue)) && isFinite(aValue);
    const isNumericB = !isNaN(parseFloat(bValue)) && isFinite(bValue);
  
    if (isNumericA && isNumericB) {
      // Numeric comparison
      return parseFloat(aValue) - parseFloat(bValue);
    }
  
    // String comparison
    if (aValue < bValue) return -1;
    if (aValue > bValue) return 1;
    return 0;
  }
  
  // Comparator function for sorting order
  function getComparator(order, orderBy) {
    return order === 'asc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  // Function for stable sort with index preservation
  function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleInputChange = (e) => {
    let value = e.target.value
    // setSearchValue(e.target.value);
    document.getElementById('searchInputDataTable').value = value;
    
  }

  function searchdata() {
    const searchValue = document.getElementById('searchInputDataTable').value
    if (searchValue) {
      const filteredResult = filteredData.filter((item) => {
        return Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(searchValue.toLowerCase())
        );
      });
      console.log(filteredResult)
      if(filteredResult.length>0){
        setDataSource(filteredResult)
      }else{
        alert('No Record Found')
      }
    }
  }

  // useEffect(() => {
  //   const startIndex = page * rowsPerPage;
  //   const endIndex = startIndex + rowsPerPage;
  //   if (dataSource) {
  //     setFilteredData(stableSort(dataSource, getComparator(order, orderBy)).slice(
  //       startIndex,
  //       endIndex,
  //     ))
  //   }
  // }, [dataSource, order, orderBy, page, rowsPerPage])

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSource.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(dataSource, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, dataSource],
  );

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  //
  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          mt: 3,
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: '1 1 100%' }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            sx={{ flex: '1 1 100%' }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            <div className={classes.filtersearch}>
              <input  id="searchInputDataTable" type="text" onChange={handleInputChange} className={classes.searchInput} placeholder="Search" />
              {/* <div className={classes.searchbtn} onClick={searchdata}><BsSearch /></div> */}
              <IconButton onClick={searchdata}>
                <BsSearch />
              </IconButton>
            </div>
          </Typography>
        )}

        {numSelected > 0 ? (
          <>
          </>
        ) : (
          <>
          </>
        )}
      </Toolbar>
    );
  }
  function resetTable(data) {
    if (data.dataRecevied.statusCode === "SUCCESS" || data.dataRecevied.statusCode === "Success") {
      setRefresh(!refresh)
      setEditRowOpen()
    }
  }

  async function updateData(data, index, path) {
    //console.log(path)
    try {
      const response = await APIPATCH(apiContextObj.apiContextSave + path + data[apiContextObj.id], data, formFieldsJson, resetTable, {});
      if (response) {
        response.then((responseData) => {
        })
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  //************************* xls
  function generateXLSX(data, headers) {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers.map(header => header.dataIndex) });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    return new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  const downloadXLSX = (data, headers) => {
    const xlsBlob = generateXLSX(data, headers);
    const url = URL.createObjectURL(xlsBlob);
    const link = document.createElement('a');

    // Assuming contextHeading is a property in data or headers
    const filename = (apiContextObj.contextHeading || '').toLowerCase().replace(" ", "_") + ".xlsx";

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //*****************((((((pdf)))))) */

  function generatePDF(data, headers) {
    const table = {
      width: 100,
      headerRows: 1,
      body: [
        headers.map(header => header.title),
        ...data.map(row => headers.map(header => row[header.dataIndex] || ''))
      ]
    };
    const headerContent = [
      { text: apiContextObj.contextHeading, style: 'header' },
    ];

    const documentDefinition = {
      content: [
        {
          columns: [
            { width: '*', text: '' },
            { width: 'auto', stack: headerContent, margin: [0, 0, 0, 10] },
            { width: '*', text: '' },
          ]
        },
        { table: table }
      ],
      styles: {
        header: {
          fontSize: 12,  // Set the font size to 12px
          bold: true,
          margin: [0, 0, 0, 10]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 12,  // Set the font size to 12px
          color: '#363636'
        }
      },
      defaultStyle: {
        fontSize: 12,
      }
    };


    return pdfMake.createPdf(documentDefinition);
  }

  const downloadPDF = (data, headers) => {
    const pdfDoc = generatePDF(data, headers);
    pdfDoc.download((apiContextObj.contextHeading || '').toLowerCase().replace(" ", "_") + '.pdf');
  };

  const handleInvoiceInfo = (id) => {
    if (apiContextObj.editFlow.routeFlow.routes && id) {
      let pathname = `${apiContextObj.editFlow.routeFlow.routes}/${id}`;
      navigate(pathname);
    }
  };

  //Rendering Rows
  function RenderRow(row, index) {
    if (index < dataSource.length) {
      let arr = row;
      const postData = arr
      let keys = _columns?.map((column) => ({
        dataIndex: column.dataIndex,
        field_type: column.field_type,
      }));


      function setDataOnEdit() {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields = updatedEditJson.fields.map((field) => {
          if (field.field_id in arr) {
             
            return { ...field, field_value: arr[field.field_id] };
          }
          return field;
        });

        setEditJson(updatedEditJson);
      }



      // 
      const isSelected = (name) => selected.indexOf(name) !== -1;
      const isItemSelected = isSelected(row[apiContextObj.id]);

      const labelId = `enhanced-table-checkbox-${index}`;


      function verifyStatus(originalData, index) {
        const contaxt = '/approve/'
        const newData = {
          ...originalData
        };
        updateData(newData, index, contaxt)
      }

      function tablecellValue(key) {
        if (typeof key === 'string') {
          return arr[key]
        } else if (Array.isArray(key)) {
          let value = "";
          for (const item of key) {
            if (item.column) {
              value += String(arr[item.column] || '');
            } else if (item.condition) {
              value += eval(item.condition);
            } else if (item.string) {
              value += item.string;
            }
          }
          return value;
        } else {
          // It is neither a string nor an array.
          return null; // Set the return value to null explicitly.
        }
      }
// console.log(tablecellValue('allocation'))
      const handleChange = (id, event, value) => {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields = updatedEditJson.fields.map((field) => {
          if (id === field.field_id) {
            //console.log(value)
            postData[field.field_id] = value;
            return { ...field, field_value: value };
          }
          return field;
        });

        setEditJson(updatedEditJson);
      };  
      console.log(keys.map((key) => arr[key.dataIndex]))
      return (
        <React.Fragment>
          <TableRow
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            // key={row[apiContextObj.id]}
            selected={isItemSelected}
            sx={{ cursor: 'pointer' }}
          >
            {/* <StyledTableCell padding="checkbox">
              <Checkbox
                color="primary"
                checked={isItemSelected}
                onClick={(event) => handleClick(event, row[apiContextObj.id])}
                inputProps={{
                  'aria-labelledby': labelId,
                }}
              />
            </StyledTableCell> */}
            {keys?.map((key) => (
                (String(arr[key.dataIndex]) === "null" || String(arr[key.dataIndex]) === "") && key.dataIndex === "varifiedbyusername" ?
                  <StyledTableCell onClick={() => verifyStatus(postData, index)} value={String(arr[key.dataIndex])}>
                    <span style={{ color: '#0055d4' }}>Verify</span>
                  </StyledTableCell> :
                    <StyledTableCell value={String(arr[key.dataIndex])}>
                      {
                        key.field_type && editRowOpen === index ?
                          <FormContext.Provider value={{ handleChange }}>
                            {editJson.fields && editJson.fields.map((field, i) => {
                              if (field.field_id === key.dataIndex) {
                                return (<Element key={i} field={field} />)
                              }
                            })
                            }
                          </FormContext.Provider> :
                          <div style={{ display: 'flex' }}>
                            <span></span>
                            <div>{tablecellValue(key.dataIndex)}</div>
                          </div>
                      }
                    </StyledTableCell>
            ))}

            {(apiContextObj?.detailsFlow?.tableAction) ? <StyledTableCell className='actionTd'>

            {apiContextObj?.detailsFlow?.detailsFlow.auth&&<button className={classes.atnBtn} onClick={() => { setOpenDetails(true); setViewPosition(index) }}>{apiContextObj?.detailsFlow?.detailsFlow?.btnName}</button>}
            </StyledTableCell> : null}
          </TableRow>
        </React.Fragment>
      );
    }
  }

  const handleClose = () => {
    setErrorOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = dataSource.map((n) => n[apiContextObj.id]);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <React.Fragment>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={errorOpen} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog className={classes.popupEdit}
        open={openDetails}
        maxWidth="md"
        // maxWidth={fullScreen}
        onClose={() => setOpenDetails(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Details index={viewPosition} dataArr={visibleRows[viewPosition]} detail={dataArr} apiContextObj={apiContextObj.detailsFlow} close={() => setOpenDetails(false)} viewJson={obj.viewJson} contextJson={contextJson} searchJson={searchJson}/>
      </Dialog>

    <div className={classes.detailsPopup}>
    <div className={classes.headerSticky}>
        <CloseIcon onClick={obj.close} />
        <h4>{apiContextObj.detailsFlow.contextHeading}</h4>
      </div>
    <div>
    {loading ?
        <div className={classes.loader}>
          <img src={Loading} alt="Loading..." />
        </div> :
            <>

              {apiContextObj?.detailsFlow?.listItem &&<ul className={classes.ErhMapLbl}>
                {apiContextObj?.detailsFlow?.listItem.map((item, index) => (
                  <li key={index}>
                    <span>{item.field_lable}</span>
                    <span>{dataArr[item.field_id]}</span>
                  </li>
                ))}
              </ul>}

              <EnhancedTableToolbar numSelected={selected.length} />
              <TableContainer className={classes.table}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {/* <StyledTableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          indeterminate={selected.length > 0 && selected.length < dataSource.length}
                          checked={dataSource.length > 0 && selected.length === dataSource.length}
                          onChange={handleSelectAllClick}
                          inputProps={{
                            'aria-label': 'select all desserts',
                          }}
                        />
                      </StyledTableCell> */}
                      {_columns?.map((column, i) => (<StyledTableCell
                        // key={i}
                        // align={column.numeric ? 'right' : 'left'}
                        // padding={column.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === column.dataIndex ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === column.dataIndex}
                          direction={orderBy === column.dataIndex ? order : 'asc'}
                          onClick={createSortHandler(column.dataIndex)}
                        >
                          {column.title}
                          {orderBy === column.dataIndex ? (
                            <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      </StyledTableCell>
                      ))}
                      {(apiContextObj?.detailsFlow?.tableAction)&&<StyledTableCell>ACTION</StyledTableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {visibleRows.length>0?visibleRows.map((arr, index) => (RenderRow(arr, index))):
                    <TableRow> <StyledTableCell colSpan={_columns.length+1}>No Data</StyledTableCell></TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
              <div className={classes.pagination}>
                <TablePagination
                  component="div"
                  labelRowsPerPage='Show row per page'
                  count={dataSource.length}
                  page={page}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 50, 100, 500]}
                />
              </div>
            </>
      }
    </div>
    </div>
     
    </React.Fragment>
  );
}